import { Stack, Typography } from '@mui/material';
import { IVehiclesCapacitiesShort } from '@helpers/types.ts';
import { vehicle_icons } from '@helpers/constants.tsx';

interface IVehicleLabelProps {
  vehicles: IVehiclesCapacitiesShort;
}

export const VehicleLabel = (props: IVehicleLabelProps) => {
  return (
    <Stack
      direction="row"
      width={'100%'}
      alignContent={'space-evenly'}
      justifyContent={'space-evenly'}
    >
      {(Object.keys(props.vehicles) as Array<keyof IVehiclesCapacitiesShort>).map((s) => (
        <div key={s}>
          {vehicle_icons[s as keyof typeof vehicle_icons]}
          <Typography variant="body1" color="secondary" fontWeight="bold">
            {props.vehicles[s]}
          </Typography>
        </div>
      ))}
    </Stack>
  );
};
